import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "@/components/layout/app-layout";
import { LoginPage } from "@/pages/login";
import { DashboardPage } from "@/pages/dashboard";
import { UsersPage } from "@/pages/users";
import { UserDetailPage } from "@/pages/user-detail";
import { VenuesPage } from "@/pages/venues";
import { VenueDetailPage } from "@/pages/venue-detail";
import { IngredientsPage } from "@/pages/ingredients";
import { PlansPage } from "@/pages/plans";
import { EventsPage } from "@/pages/events";
import { BackgroundsPage } from "@/pages/backgrounds";
import { AppSettingsPage } from "@/pages/app-settings";
import { EmailTestPage } from "@/pages/email-test";
import { CustomDomainsPage } from "@/pages/custom-domains";
import { PaymentsPage } from "@/pages/payments";
import { StoragePage } from "@/pages/storage";
import { CreditPackagesPage } from "@/pages/credit-packages";
import { TrashPage } from "@/pages/trash";
import { EmailTemplatesPage } from "@/pages/email-templates";
import { RouteErrorBoundary } from "@/components/error-boundary";

// See dashboard's routes/index.tsx for the rationale — `errorElement`
// prevents the "💿 Hey developer" React Router fallback from leaking to
// production users when a render throws.
export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "users", element: <UsersPage /> },
      { path: "users/:id", element: <UserDetailPage /> },
      { path: "venues", element: <VenuesPage /> },
      { path: "venues/:id", element: <VenueDetailPage /> },
      { path: "ingredients", element: <IngredientsPage /> },
      { path: "plans", element: <PlansPage /> },
      { path: "events", element: <EventsPage /> },
      { path: "backgrounds", element: <BackgroundsPage /> },
      { path: "app-settings", element: <AppSettingsPage /> },
      { path: "email-test", element: <EmailTestPage /> },
      { path: "custom-domains", element: <CustomDomainsPage /> },
      { path: "payments", element: <PaymentsPage /> },
      { path: "storage", element: <StoragePage /> },
      { path: "credit-packages", element: <CreditPackagesPage /> },
      { path: "trash", element: <TrashPage /> },
      { path: "email-templates", element: <EmailTemplatesPage /> },
    ],
  },
]);
